/* eslint-disable import/no-extraneous-dependencies */

import isEmpty from 'lodash/isEmpty';

import React from 'react';
import styled from 'styled-components';

import AntdIcon from 'antd/lib/icon';

import {
  ArrowUpOutlined,
  ArrowRightOutlined,
  ArrowDownOutlined,
  ArrowLeftOutlined,
} from '@ant-design/icons';

import Admin from 'hive-admin';
import {
  asLocalStorageField,
} from 'hive-admin/src/components/FieldLocalStorage';

import { Tooltip } from 'hive-admin/src/components/Popover';
import { getSidebarField } from '../../ActionSidebar';

import modifyFieldConfig from '../../../helpers/modifyFieldConfig';

const LayoutIcon = styled(AntdIcon)`

`;

const LAYOUT_FIELDS_CONFIG = {
  ...[
    [
      'hidden',
      [
        [true, 'Yes'],
        [false, 'No'],
      ],
      false,
    ],
    [
      'display',
      [
        ['FLEX', 'Flex'],
        ['INLINE', 'Inline'],
      ],
      'FLEX',
    ], [
      'position',
      [
        ['STATIC', 'Static'],
        ['RELATIVE', 'Relative'],
        ['ABSOLUTE', 'Absolute'],
      ],
      'STATIC',
    ], [
      'direction',
      [
        // eslint-disable-next-line react/jsx-key
        ['ROW', <ArrowRightOutlined />, 'Row'],
        // eslint-disable-next-line react/jsx-key
        ['COLUMN', <ArrowDownOutlined />, 'Column'],
        // eslint-disable-next-line react/jsx-key
        ['ROW_REVERSE', <ArrowLeftOutlined />, 'Row Reverse'],
        // eslint-disable-next-line react/jsx-key
        ['COLUMN_REVERSE', <ArrowUpOutlined />, 'Column Reverse'],
      ],
      'COLUMN',
    ], [
      'flexWrap',
      [
        ['WRAP', 'Wrap'],
        ['NOWRAP', 'No Wrap'],
      ],
      'WRAP',
    ], [
      'overflow',
      [
        ['VISIBLE', 'Visible'],
        ['HIDDEN', 'Hidden'],
      ],
      'VISIBLE',
    ], [
      'alignSelf',
      [
        ['AUTO', 'Self A'],
        ['START', 'Self S'],
        ['CENTER', 'Self C'],
        ['END', 'Self E'],
      ],
      'AUTO',
    ], [
      'alignPrimary',
      [
        ['START', 'S'],
        ['CENTER', 'C'],
        ['END', 'E'],
        ['BETWEEN', 'SB'],
        ['AROUND', 'SA'],
        ['EVENLY', 'SE'],
      ],
      'START',
    ], [
      'alignSecondary',
      [
        ['START', 'S'],
        ['CENTER', 'C'],
        ['END', 'E'],
      ],
      'START',
    ], [
      'pointerEvents',
      [
        ['AUTO', 'Auto'],
        ['ALL', 'All'],
        ['NONE', 'None'],
      ],
      'AUTO',
    ],
  ].reduce(
    (agr, [name, choices, initialValue, config = {}]) => {
      agr[name] = ['FieldRadio', {
        label: null,
        name,
        initialValue,
        choices: choices.map(([value, label, labelText]) => ({
          label,
          labelText,
          value,
        })),
        [Admin.LIBRARY_NAME_KEY]: 'FieldRadio',
        block: true,
        ...config,
      }];
      return agr;
    },
    {},
  ),
};

// import getFilterWithCol from '../../../helpers/getFilterWithCol';

const isNotFrame = Admin.compileFromLibrary([
  'condition.testFieldValue',
  'type',
  '!==',
  'FRAME',
]);

const isFrameViewingEffects = Admin.compileFromLibrary([
  'condition.testFieldValue',
  '_viewing',
  '===',
  'effects',
]);

const isFrameNotViewingEffects = Admin.compileFromLibrary([
  'condition.testFieldValue',
  '_viewing',
  '!==',
  'effects',
]);

const isFrameViewingEffectsHover = Admin.compileFromLibrary([
  'condition.testFieldValue',
  '_viewing',
  '===',
  'effectsHover',
]);

const isFrameNotViewingEffectsHover = Admin.compileFromLibrary([
  'condition.testFieldValue',
  '_viewing',
  '!==',
  'effectsHover',
]);

const getTextField = ([name, placeholder, config = {}]) => (['FieldText', {
  label: null,
  name,
  placeholder,
  ...config,
}]);

getTextField.row = (...rowFieldConfigs) => rowFieldConfigs.map(
  getTextField,
);

getTextField.sidesRows = (prefix) => {
  prefix = `${prefix ? `${prefix}.` : ''}`;
  return [
    getTextField.row(
      ...['Top', 'Right'].map((sideLabel) => {
        const sideName = sideLabel.toLowerCase();
        return [`${prefix}${sideName}`, sideLabel];
      }),
    ),
    getTextField.row(
      ...['Bottom', 'Left'].map((sideLabel) => {
        const sideName = sideLabel.toLowerCase();
        return [`${prefix}${sideName}`, sideLabel];
      }),
    ),
  ];
};

export default [
  ...[
    'frame_viewing',
    ...[
      '',
      'Mobile',
      'Tablet',
      'Desktop',
    ].map(suffix => `frame_layout${suffix}`),
  ].map(name => Admin.compileFromLibrary(['FieldHidden', {
    name,
    label: null,
    preSkip: [isNotFrame],
  }])),
  ...[
    //
  ].map(([fieldType, fieldConfig]) => Admin.compileFromLibrary([
    fieldType,
    {
      ...fieldConfig,
      hidden: [isFrameViewingEffects, ...(fieldConfig.hidden || [])],
      preSkip: [isNotFrame, ...(fieldConfig.preSkip || [])],
    },
  ])),
  ['FieldContentBuilderItems', {
    name: 'frame_items',
    hidden: [isFrameViewingEffects, isFrameViewingEffectsHover],
    preSkip: [isNotFrame],
  }],
  ['FieldContentBuilderEffectsFrame', {
    name: 'frame_effects',
    hidden: [isFrameNotViewingEffects],
    preSkip: [isNotFrame],
  }],
  ['FieldContentBuilderEffectsFrame', {
    name: 'frame_effectsHover',
    hidden: [isFrameNotViewingEffectsHover],
    preSkip: [isNotFrame],
    addButtonLabel: 'Add Hover Effect',
    pasteButtonLabel: 'Paste Hover Effect',
  }],
];

export const sidebarFields = [
  getSidebarField(['FieldHidden', {
    name: 'hide',
    hidden: [() => true],
    label: null,
  }]),
  ...getSidebarField.section(
    {
      name: 'hide_cb_sidebar_frame',
      title: 'Frame',
      subtitle: 'Visual arrangement, dimensions, and alignment controls.',
      // help: 'Fine-tune the visual presentation and arrangement of your website components by adjusting aspects such as display, position, dimensions, alignment, margins, and padding, while also leveraging flexible properties like flex for dynamic layouts.',
      initialValue: true,
    },
    [
      asLocalStorageField(['FieldRadio', {
        name: 'cb_sidebar_frame_layout',
        initialValue: 'GENERAL',
        label: null,
        block: true,
        renderChoices: (field, props) => (
          [
            ['General', '', 'layout'],
            ['Mobile', 'Mobile', 'mobile'],
            ['Tablet', 'Table', 'tablet'],
            ['Desktop', 'Desktop', 'desktop'],
          ].map(([label, suffix, icon]) => {
            let annotation = null;
            let hidden = false;
            if (suffix !== '') {
              const formValues = props.form.getFieldsValue();
              const {
                [`frame_layout${suffix}`]: values,
              } = formValues || {};
              const {
                hide = [],
              } = props.data || {};
              hidden = hide.includes(suffix.toUpperCase());
              const changesCount = (
                !values
                ? 0
                : Object.keys(values).reduce(
                    (agr, key) => {
                      const value = values[key];
                      if (!isEmpty(value)) {
                        if (
                          ['margin', 'padding', 'absolute']
                          .includes(key)
                        ) {
                          return agr + Object.values(value).reduce(
                            (subAgr, subValue) => (
                              subAgr + (!isEmpty(subValue) ? 1 : 0)
                            ),
                            0,
                          );
                        }
                        return agr + 1;
                      }
                      return agr + 0;
                    },
                    0,
                  )
              );
              if (changesCount > 0) {
                annotation = (
                  <span
                    style={{
                      position: 'absolute',
                      opacity: hidden ? 0.4 : 1,
                    }}
                  >
                    &nbsp;
                    <sup>{changesCount}</sup>
                  </span>
                );
              }
            }
            return {
              label: (
                <>
                  <LayoutIcon
                    type={icon}
                    style={
                      hidden
                      ? { opacity: 0.4 }
                      : undefined
                    }
                  />
                  {annotation}
                </>
              ),
              text: suffix,
              value: label.toUpperCase(),
            };
          }).map(choice => (
            <Tooltip
              key={choice.value}
              title={`${
                choice.text ? `${choice.text} Overrides` : 'General'
              }`}
            >
              {props.renderChoice(choice, field, props)}
            </Tooltip>
          ))
        ),
      }]),
      // Fields
      ...[
        ['GENERAL', ''],
        ['MOBILE', 'Mobile'],
        ['TABLET', 'Tablet'],
        ['DESKTOP', 'Desktop'],
      ].reduce(
        (topAgr, [value, suffix]) => {
          topAgr.push(...[
            // ...getSidebarField.block(
            //   `Hide ${suffix ? `on ${suffix}` : 'Always'}`,
            //   [
            //     [LAYOUT_FIELDS_CONFIG.hidden],
            //   ],
            // ),
            ...getSidebarField.block(
              'Display',
              [
                [LAYOUT_FIELDS_CONFIG.display],
              ],
            ),
            ...getSidebarField.block(
              'Position',
              [
                [LAYOUT_FIELDS_CONFIG.position],
              ],
            ),
            ...getSidebarField.block(
              'Direction',
              [
                [LAYOUT_FIELDS_CONFIG.direction],
              ],
            ),
            ...getSidebarField.block(
              'Wrap',
              [
                [LAYOUT_FIELDS_CONFIG.flexWrap],
              ],
            ),
            ...getSidebarField.block(
              'Overflow',
              [
                [LAYOUT_FIELDS_CONFIG.overflow],
              ],
            ),
            ...getSidebarField.block(
              'Width & Height',
              [
                getTextField.row(
                  ['width', 'Width'],
                  ['height', 'Height'],
                ),
                getTextField.row(
                  ['widthMin', 'Min Width'],
                  ['heightMin', 'Min Height'],
                ),
                getTextField.row(
                  ['widthMax', 'Max Width'],
                  ['heightMax', 'Max Height'],
                ),
                getTextField.row(
                  ['aspectRatio', 'Aspect Ratio'],
                ),
              ],
            ),
            ...getSidebarField.block(
              'Pointer Events',
              [
                [LAYOUT_FIELDS_CONFIG.pointerEvents],
              ],
            ),
            ...getSidebarField.block(
              'Flex',
              [
                getTextField.row(
                  ['flexGrow', 'Grow'],
                  ['flexShrink', 'Shrink'],
                  ['flexBasis', 'Basis'],
                ),
              ],
            ),
            ...getSidebarField.block(
              'Alignment',
              [
                [LAYOUT_FIELDS_CONFIG.alignPrimary],
                [LAYOUT_FIELDS_CONFIG.alignSecondary],
                [LAYOUT_FIELDS_CONFIG.alignSelf],
                getTextField.row(
                  ['gap', 'Gap'],
                  ['order', 'Order'],
                  ['zIndex', 'Z Index'],
                ),
              ],
            ),
            ...getSidebarField.block(
              'Margins',
              [
                ...getTextField.sidesRows('margin'),
              ],
            ),
            ...getSidebarField.block(
              'Padding',
              [
                ...getTextField.sidesRows('padding'),
              ],
            ),
            ...getSidebarField.block(
              'Absolute Position',
              [
                ...getTextField.sidesRows('absolute'),
              ],
            ),
          // eslint-disable-next-line arrow-body-style
          ].map((field) => {
            return modifyFieldConfig(field, (config = {}) => {
              const newConfig = {
                ...config,
                name: (
                    config.name
                  ? `frame_layout${suffix}.${config.name}`
                  : config.name
                ),
                hidden: [
                  ...(config.hidden || []),
                  [
                    'condition.testFieldValue',
                    'cb_sidebar_frame_layout',
                    '!==',
                    value,
                  ],
                ],
              };
              if (suffix.length && field?.[0] === 'FieldRadio') {
                newConfig.toggleable = true;
                newConfig.initialValue = undefined;
              }
              return newConfig;
            });
          }));
          return topAgr
        },
        [],
      ),
    ]
  ),
].map(field => Admin.compileFromLibrary(modifyFieldConfig(field, (config) => ({
  ...config,
  preSkip: [isNotFrame, ...(config.preSkip || [])],
}))));
